import { Injectable, ErrorHandler, inject } from '@angular/core';
import { environment } from '@env/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CustomErrorService implements ErrorHandler {

  private router = inject(Router);

  handleError(error: unknown): void {

    try {
      const httpError = error as HttpErrorResponse;
      if (httpError.status === 401) {
        this.router.navigate(['/authentication/signin']);
      }
    }
    catch { }


    throw(error); 
  }
}
